module.exports = __webpack_public_path__ + "static/media/speakers2.f6ff943a.jpg";